"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuPart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
//--------Menu Parts--------//
var MenuPartBaseClasses = function (type, active, tightRight, tightLeft) {
    return "\n  flex\n  justify-between\n  items-center\n  rounded-component-menu-item-border-radius\n  w-full\n  ".concat(type === 'sm'
        ? 'h-component-menu-item-height-sm'
        : type === 'md'
            ? 'h-component-menu-item-height-md'
            : 'h-component-menu-item-height-lg', "\n  ").concat(!active &&
        "hover:bg-alias-state-base-hover\n    active:bg-alias-state-base-pressed", "\n  ").concat(active && 'bg-alias-state-base-active', "\n  ").concat(tightRight
        ? 'pr-alias-menu-part-padding-tight'
        : 'pr-alias-menu-part-padding-base', "\n  ").concat(tightLeft
        ? 'pl-alias-menu-part-padding-tight'
        : 'pl-alias-menu-part-padding-base', "\n  ");
};
/** MenuPart
 * @param {'sm' | 'md' | 'lg'} type item size
 * @param {boolean} active (optional) active styling
 * @param {TextGroup} textGroup TextGroup component to label the item
 * @param {boolean} tightRight (optional) tight padding on right side
 * @param {boolean} tightLeft (optional) tight padding on left side
 * @param {React.ReactNode} leftComponent (optional) component to show on left side
 * @param {React.ReactNode} rightComponent (optional) component to show on right side
 * @param {Function} onClick (optional) function to be executed on click
 */
var MenuPart = function (props) {
    var type = props.type, active = props.active, textGroup = props.textGroup, tightRight = props.tightRight, tightLeft = props.tightLeft, leftComponent = props.leftComponent, rightComponent = props.rightComponent, onClick = props.onClick, dataTestID = props["data-testid"];
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ role: "menuitem", className: MenuPartBaseClasses(type, active, tightRight, tightLeft), onClick: function () {
            onClick && onClick();
        }, onKeyDown: function (e) {
            if (e.code === 'Space' || e.code === 'Enter') {
                onClick && onClick();
            }
        }, "data-testid": dataTestID }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-alias-menu-part-space items-center" }, { children: [leftComponent, textGroup] })), rightComponent] })));
};
exports.MenuPart = MenuPart;
